import { setLocale, addMethod, mixed, string } from 'yup'

setLocale(
  {
    mixed: {
      required: (obj) => {
        const message = I18n.t('errors.messages.blank')
        const label = obj.label

        if (!label) { return message }
        return `${label} ${message}`
      }
    },

    string: {
      email: (obj) => {
        const message = I18n.t('errors.messages.format')
        return message
      }
    }
  }
)

function equalTo(ref, msg) {
  return mixed().test({
    name: 'equalTo',
    exclusive: false,
    message: msg || function (obj) {
      const message = I18n.t('errors.messages.confirmation', {
        attribute: obj.label || obj.path
      })

      return message
    },
    params: {
      reference: ref.path
    },
    test: function(value) {
      return value === this.resolve(ref);
    },
  });
}

addMethod(string, 'equalTo', equalTo);

export * from 'yup'
